var _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesforce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 24",
    role: "img",
    "aria-label": "Salesforce",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00A1E0",
    d: "M14 6.5c-1.2-1.8-3.3-3-5.7-3C4.4 3.5 1 7 1 11.2s3.4 7.7 7.3 7.7c2.1 0 4-.9 5.3-2.3.8 2.8 3.4 4.8 6.5 4.8 3.7 0 6.7-3 6.7-6.7s-3-6.7-6.7-6.7c-1.4 0-2.7.4-3.8 1.1-.6-1.5-2-2.6-3.6-2.6-1.2 0-2.2.5-2.7 1.2Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 18,
    fill: "#032D60",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 600
  }, "salesforce")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesforce);
export default __webpack_public_path__ + "static/media/salesforce.c7b56b6b010494e76f0d774fb8b0c7ad.svg";
export { ForwardRef as ReactComponent };